<template>
  <v-menu
    offset-y
    transition="slide-y-transition"
    data-testid="horizon-role-switcher"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        v-on="on"
        class="tasklist-dropdown-btn"
        data-testid="horizon-role-switcher__trigger"
      >
        <img
          src="/img/icons/EyeIcons.svg"
          alt="Eye Icon"
          class="role-switcher__icon"
        />

        <span>{{ currentLabel }}</span>
        <img
          src="/img/icons/downArrow.svg"
          alt="Down Arrow"
          class="role-switcher__chevron ml-1"
        />
      </v-btn>
    </template>

    <v-list dense data-testid="horizon-role-switcher__list">
      <v-list-item
        v-for="role in visibleRoles"
        :key="role.value"
        :class="{
          'role-switcher__item--active v-list-item--active':
            role.value === value,
        }"
        @click="onSelect(role.value)"
        data-testid="horizon-role-switcher__option"
      >
        <v-list-item-title>{{ role.label }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import "./RoleSwitcher.scss";
import constants from "@/plugins/constants";

const { ROLES } = constants.TASK_LIST_CONSTANTS;

export default {
  name: "RoleSwitcher",

  props: {
    value: {
      type: String,

      default: ROLES.MANAGER,
    },

    showPreparer: {
      type: Boolean,

      default: true,
    },

    showManager: {
      type: Boolean,

      default: true,
    },
  },

  computed: {
    roleConstants() {
      return this.$constants.TASK_LIST_CONSTANTS;
    },

    visibleRoles() {
      const { ROLES, ROLE_OPTIONS } = this.roleConstants;
      return ROLE_OPTIONS.filter((role) => {
        if (role.value === ROLES.PREPARER && !this.showPreparer) return false;

        if (role.value === ROLES.MANAGER && !this.showManager) return false;

        return true;
      });
    },

    currentLabel() {
      const { ROLE_OPTIONS, ROLE_DEFINITIONS } = this.roleConstants;
      const match = ROLE_OPTIONS.find((r) => r.value === this.value);

      return match?.label || this.visibleRoles[0]?.label || ROLE_DEFINITIONS.PREPARER.label;
    },
  },

  methods: {
    onSelect(role) {
      if (role === this.value) return;

      this.$emit("input", role);

      this.$emit("change", role);
    },
  },
};
</script>
